import {
    initCardsCarousel,
    destroyCardsCarousel,
    initCardsListing as initBaseCardsListing,
    type ListingColumnsMap,
} from '../../cards/src/view';
import { initVideoPlayers } from '@sts/components/ui/Video/view';
import { getBreakpointValue } from '@sts/utils/tokens';

const BREAKPOINT_LG = getBreakpointValue('lg');

const LISTING_COLUMNS: ListingColumnsMap = {
    xlg: [
        { width: BREAKPOINT_LG, columns: 3 },
        { width: 0, columns: 1 },
    ],
    lg: [
        { width: BREAKPOINT_LG, columns: 3 },
        { width: 0, columns: 1 },
    ]
};

const CONTENT_LISTING_SELECTOR =
    '.wp-block-sts-content-listing-carousel.sts-block-cards--listing';

const initCardsListing = (root: ParentNode | Document | null = document) =>
    initBaseCardsListing(root, {
        blockSelector: CONTENT_LISTING_SELECTOR,
        columns: LISTING_COLUMNS,
    });

const init = () => {
    initCardsCarousel(document);
    initCardsListing(document);
    initVideoPlayers(document);
};

if (typeof document !== 'undefined') {
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', init);
    } else {
        init();
    }
}

export { initCardsCarousel, destroyCardsCarousel, initCardsListing, initVideoPlayers };
